import React from "react";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/other/Loader";
import { pageRoutes } from "../../routes/pageRoutes";
import ErrorMessage from "../../components/ErrorMessage";
import { forgotPasswordSchema } from "../../utils/schema";
import { authForgotPassword } from "../../redux/action/authAction";

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoading } = useSelector((state) => state.authReducer);
  const initialState = {
    email: "",
  };

  const handleForgotPassword = async (values, { setSubmitting }) => {
    const callback = (response) => {
      if (response.success) navigate(pageRoutes?.login);
    };
    dispatch(authForgotPassword({ payload: values, callback }));
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div class="ct_profile_bg">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 mx-auto">
            <div class="ct_profile_white_bg py-5 ct_unset_animation">
              <div class="ct_section_title">
                <h2 class="section-title mb-4 text-center">
                  <strong>Forgot Password?</strong>
                </h2>
              </div>

              <Formik
                initialValues={initialState}
                validationSchema={forgotPasswordSchema}
                onSubmit={(values, actions) => {
                  handleForgotPassword(values, actions);
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="col-md-12 ct_input-group mb-4">
                          <input
                            required=""
                            type="email"
                            name="email"
                            autocomplete="off"
                            class="ct_input"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                            placeholder="Enter email"
                          />

                          <label class="ct_user-label">Email</label>
                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName="email"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="text-center">
                      <button
                        class="btn btn-secondary ct_btn_animate mt-4 text-center mx-auto"
                        type="button"
                        onClick={handleSubmit}
                      >
                        Send Password
                      </button>

                      <p class="text-center mt-2 ct_fs_16 mb-0">
                        Already know your password?{" "}
                        <a
                          href="javascript:void(0)"
                          onClick={() => navigate(pageRoutes?.login)}
                          style={{ color: "#f6ab4b" }}
                        >
                          <strong>Sign In</strong>
                        </a>
                      </p>
                    </div>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
